<template>
  <div class="el-core__header">
    <app-core-header-left />
    <app-core-header-right />
  </div>
</template>

<script>
import AppCoreHeaderLeft from './AppCoreHeaderLeft'
import AppCoreHeaderRight from './AppCoreHeaderRight'
export default {
  name: 'AppCoreHeader',
  components: {
    AppCoreHeaderLeft,
    AppCoreHeaderRight
  },
  data () {
    return {
      showAccountList: false
    }
  },
  computed: {
    merchant () {
      return this.$store.getters.merchantData
    },
    account () {
      return this.$store.getters.accountData
    },
    status () {
      if (this.account === null) return false
      if (this.account.account_type.key === 'test') {
        return { key: 'test', value: this.$t('status.test') }
      }
      return this.statusSerializer(this.statusAccount)
    },
    statusAccount () {
      if (this.merchantBlocked) return 'blocked'
      const getterStatusAccount = this.account.status

      return getterStatusAccount ? getterStatusAccount.key || getterStatusAccount : ''
    },
    merchantBlocked () {
      return this.$store.getters.isDelinquent
    },
    accountName () {
      return !this.isTestAccount ? this.account.name : this.account.master_account_name
    },
    urlCompany () {
      return `${process.env.VUE_APP_COMPANY_URL}/${this.$route.params.merchant_id}`
    }
  },
  methods: {
    toggleAccountList () {
      this.showAccountList = !this.showAccountList
    },
    statusSerializer (statusName) {
      return {
        key: statusName === 'blocked' ? 'inactive' : statusName,
        value: this.$t(`status.${[statusName]}`)
      }
    },
    clickedOutside (e) {
      if (!this.$refs.appContext.contains(e.target) && this.showAccountList) {
        this.toggleAccountList()
      }
    }
  }
}
</script>
